// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"7b355734","710":"ce737f76","712":"3fa52853","983":"064fde51"}[chunkId] + ".chunk.js";
};